<template>
	<div class="detailedbox" v-if="fieldlist.length">
		<!--
		
		
		-->
		<div class="detfield_boxs"
		v-for="(item1, index1) in classlist"
		v-if="fieldlist.some(v=>v.type == item1.type)">
			
			<div v-if="!prohiname.some(v=>v == item1.name)">
				<div class="detfield_tit Flexalign">
					<i class="iconfont icon-a-juxing8"></i>
					<div class="tit">
						{{item1.name || ''}}
					</div>
				</div>
				<div class="detfield_content FlexWrap">
					<template v-for="(value, index) in fieldlist">  
						<template v-if="!prohibit.some(v=>v == value.field_type)">
							<div class="detfield_line Flexalign" :class="{'w100': value.field_type == 19}"
							v-if="value.type == item1.type && value.is_show">
								<div class="det_label Flexalign ">
									<div class="txt Singlerow">
										{{value.field || ''}}
									</div>
								</div>
								<div class="det_val Flexalign FlexItem" :title="value.select_field">
									<div class="txt Singlerow">
										{{value.select_field || ''}}
									</div>
								</div>
							</div>
						</template>
						<template v-else-if="value.field_type == 19">
							<div  v-html="value.content">
							</div>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var that;

	
	export default {
		components: {
	
		},
		name: "detailsdisplay",

		props: {
			//
			classlist: {
				type: Array,
				default: () => {
					return [];
				},
			},
			fieldlist: {
				type: Array,
				default: () => {
					return [];
				},
			},


			isshow: {
				type: Boolean,
				default: false,
			},


			// 基础数据 是否加载完成
			loading: {
				type: Boolean,
				default: true,
			},

		},
		data() {
			return {
				prohibit: [7,8,19,20],
				prohiname: ['附件信息', '产品信息'],
				
			};
		},

		created() {
			that = this;
			
		},
		watch: {

		},
		methods: {

		},
	};
</script>

<style scoped lang="scss">
	// @import "../../css/projecticon.css";

	/deep/ .el-input.is-disabled .el-input__inner {
		color: rgba(96, 98, 102, 1) !important;
	}

	/deep/ .detailedbox .el-form-item {
		width: 100%;
	}

	/deep/ .detailedbox .el-form-item__content {
		width: 500px !important;
	}

	.detfield_boxs {
		width: 100%;
		margin-bottom: 50px;
		.detfield_tit {
			width: 100%;
			margin-bottom: 23px;

			i {
				color: var(--themeColors);
				font-size: 14px;
			}

			.tit {
				font-size: 14px;
				font-weight: 400;
				margin-left: 6px;
				color: rgba(46, 64, 94, 1);
			}
		}

		.detfield_content {
			width: 100%;
			.detfield_line.w100{
				width: 100%;
			}
			.detfield_line:nth-last-child(-n+2) {
				.det_label {
					border-bottom: 1px solid rgba(238, 238, 238, 1);
				}

				.det_val {
					border-bottom: 1px solid rgba(238, 238, 238, 1);
				}
			}
			.detfield_line:nth-child(even) {
				.det_val {
					border-right: 1px solid rgba(238, 238, 238, 1);
				}
			}
			.detfield_line:nth-child(odd) {
				.det_label {
					border-left: 1px solid rgba(238, 238, 238, 1);
				}
			}
			
		
			.detfield_line {
				width: 50%;
				min-height: 42px;

				.det_label {
					width: 141px;
					height: 100%;
					background: rgba(250, 251, 251, 1);
					border: 1px solid rgba(238, 238, 238, 1);
					border-bottom: 0;
					border-right: 0;
					padding: 0 14px;
					border-left: 0;
					.txt {
						max-width: 100%;
						font-size: 13px;
						font-weight: 400;
						color: rgba(144, 154, 170, 1);
					}
				}

				.det_val {
					background: rgba(255, 255, 255, 1);
					height: 100%;
					border: 1px solid rgba(238, 238, 238, 1);
					padding: 0 14px;
					border-bottom: 0;
					

					.txt {
						max-width: 280px;
						font-size: 13px;
						font-weight: 400;
						color: rgba(46, 64, 94, 1);
					}
				}
			}
		}
	}
</style>